<template lang="pug">
  lei-modal.login-modal(:title="title" size="sm" :close-with-overlay="false"
    @close="closeLoginModal"
    @keypress.enter.native="submit" )
    .container.form-wrap
      el-form.form(ref="loginForm" :model="loginForm" :rules="rules" label-position="top" status-icon)
        el-row(:gutter="20")
          el-col(:xs="24" :sm="12")
            el-form-item(label="Email Address" prop="email")
              el-input.lei-input(placeholder="Email Address" v-model="loginForm.email" data-test="email-address")
          el-col(:xs="24" :sm="12")
            el-form-item(label="Password" prop="password")
              el-input.lei-input(
                type="password"
                placeholder="Password"
                v-model="loginForm.password"
                autocomplete="off"
                data-test="password")
    .container
      p.description {{description}}
    .container.form-navigate
      p.description {{question}}
        a.primary-link(:href="makeHref('register')" target="_blank") Register here.
      p.description
        a.primary-link(
          :href="makeHref('forgot-password')"
          target="_blank"
          data-test="forgot-password-link"
        ) Forgot password?
    div(slot="footer")
      lei-btn(type="cyprus" fill @click="submit" data-test="submit-login") {{title}}
</template>
<script>
import { mapState, mapMutations, mapActions, } from 'vuex'
import { TOGGLE_AUTH_MODAL, } from '@/store/modules/auth/mutations-types'
import { TOGGLE_LOADING, } from '@/store/mutations-types'
import { emailValidate, passwordValidate, } from '@/utils/validation'
import { challengeURL, } from '@/constants/api'
import { EventBus, } from '@/event-bus'
import Challenge from '@/mixins/challenge'
import LeiModal from '@/components/lei-components/LeiModal'
import LeiBtn from '@/components/lei-components/LeiBtn'
import AuthService from '@/services/AuthService'

export default {
  components: {
    LeiBtn,
    LeiModal,
  },
  mixins: [ Challenge, ],
  props: {
    action: {
      type: [ String, Boolean, ],
      default: '',
    },
  },
  data () {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      rules: {
        email: emailValidate,
        password: passwordValidate,
      },
    }
  },
  computed: {
    question () {
      return 'No account? '
    },
    description () {
      return 'Please log in to submit a challenge. You can also register a new account below.'
    },
    title () {
      return 'Login'
    },

    ...mapState('record/challenge', [ 'challenge', ]),
    ...mapState('search', [ 'filters', ]),
  },
  methods: {
    makeHref: (route) => `${challengeURL}${route}`,
    async submit () {
      const isValid = await this.$refs.loginForm.validate()
      if (isValid) {
        this.toggleLoading(true)
        const recaptchaToken = await this.$recaptcha('login')
        const payload = {
          email: this.loginForm.email,
          password: this.loginForm.password,
          recaptcha: recaptchaToken,
        }
        try {
          await AuthService.login(payload)
          await this.getAuthUser()
          this.successLoggedIn()
        } catch (error) {
          this.handleError(error)
        }
      }
    },
    recaptcha () {
      return this.$recaptcha('login')
    },
    successLoggedIn () {
      this.toggleLoading(false)
      if (this.action !== 'noChallenge') EventBus.$emit('logged-in')
      this.toggleModal(false)
      this.$message({
        duration: 4000,
        type: 'success',
        message: 'You have successfully logged in',
      })
    },
    handleError (e) {
      this.toggleLoading(false)
      if (e.response === undefined) {
        this.$message({
          duration: 4000,
          type: 'error',
          message: `${e.message}. Try again`,
        })
      } else {
        if (e.response.hasOwnProperty('data')) {
          this.$message({
            duration: 10000,
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: e.response.data.message,
          })
        } else {
          this.$message({
            duration: 4000,
            type: 'error',
            message: `${e.message}. Try again`,
          })
        }
      }
    },
    closeLoginModal () {
      if (this.challengeMode) this.$router.push({ name: 'RecordDetailsPage', })
      this.toggleModal(false)
    },

    ...mapMutations('auth', {
      toggleModal: TOGGLE_AUTH_MODAL,
    }),
    ...mapMutations({
      toggleLoading: TOGGLE_LOADING,
    }),
    ...mapActions('record/challenge', [ 'getField', ]),
    ...mapActions('auth', [ 'getAuthUser', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .login-modal
    &.modal
      z-index 102

    .form
      width 100%

    .form-navigate
      flex-wrap: wrap
      justify-content space-between
      padding-bottom 0

    .description
      margin-bottom 15px

  @media (min-width: $laptop)
    .login-modal
      .container
        margin-bottom 30px

        &.form-wrap
          margin-bottom 10px
</style>



// WEBPACK FOOTER //
// src/components/modals/LoginModal.vue